import './history.scss';

import Send from './../../assets/images/icons/send-money.png';
import Caution from './../../assets/images/icons/warning-rounded.png';
import Chevron from './../../assets/images/icons/chevron-down.png';
import Withdraw from './../../assets/images/icons/withdraw.png';

import Start from './../../assets/images/icons/sim.png';
import Loading from './../../assets/images/loaders/loader.gif';
import Spinner from './../../assets/images/loaders/spinner.gif';

import Skeleton from '../utils/skeleton/skeleton';

import React, { useCallback, useEffect, useRef, useState } from 'react'
import { Amount } from '../utils/amount/amount';
import { ModalTransfer } from '../utils/modal/modal';
import { useAppDispatch, useAppSelector } from '../../features';
import { getNposList, getNposProfile, getUserInfo, getUserNposList, getUserProfile } from '../../store/UserSlice';
import { cleanListTransactions, getCursorLoading, getListTransactions, getTransactionsHistory, getUserTransactionHistory, setCursorLoading } from '../../store/TransactionSlice';
import { TRKLoader } from '../utils/loader/loader';
import { getIsNpos, setModalSignInUp } from '../../store/AppSlice';
import { useInView } from 'react-intersection-observer';
import { PaymentHistoryList, PaymentsHistory } from '../../services/PaymentService';
import { modalStatusEnum, modalTypeEnum } from '../../types/modal';
import { setModalStatus } from '../../store/ModalSlice';
import { getRefreshToken } from '../../store/EncryptionSlice';
import { TransactionList } from './components/transactions';

export const History: React.FC = () => {

    // system
    const dispatch = useAppDispatch();
    const timerRef = useRef<NodeJS.Timeout | null>(null);

    // SELCTORS
    const info: any                         = useAppSelector(getUserInfo);
    const rt: string                        = useAppSelector(getRefreshToken);
    const isNpos: boolean                   = useAppSelector(getIsNpos);
    const paymentHistory: PaymentsHistory   = useAppSelector(getTransactionsHistory);
    const payments: PaymentHistoryList[]    = useAppSelector(getListTransactions);
    const isCursorLoading                   = useAppSelector(getCursorLoading)
    const listNpos : string[]               = useAppSelector(getUserNposList);
        
    // REFS
    const { ref, inView }                   = useInView({
        threshold: 0.1,   // 10% visible
        triggerOnce: false, // keep triggering
    });

    // STATES
    const [loadingActivities, setLoadingActivities] = useState<boolean>(true);
    const [loadingImg, setLoadingImg]               = useState<boolean>(true);
    const [showFilter, setShowFilter]               = useState<boolean>(false);
    const [loadingBalance, setLoadingBalance]       = useState<boolean>(false);
    const [balance, setBalance]                     = useState<number | null>(null);
    const [limit]                                   = useState<number>(20);
    const [order]                                   = useState<string>(`created_at:desc`);
    const [selectedNpos, setSelectedNpos]           = useState<Array<string>>([]);

    // LOAD TRANSACTIONS
    const getNextPage = useCallback(async (s?:string) => {
        
        setLoadingActivities(false);
        setLoadingImg(true);

        try {
            await dispatch(getUserTransactionHistory(limit, order));
        } catch (err) {
            console.log(err);
        }
    }, [dispatch]);
    
    // GET Next Page
    useEffect(() => {
        if (!isCursorLoading && inView && paymentHistory.has_next && !loadingImg) getNextPage()
    }, [inView, loadingImg])
    
    useEffect(() => {

        if (rt) {
            dispatch(cleanListTransactions());
            getNextPage('bruh');
        }

    }, [rt]);

    useEffect(() => {

        setSelectedNpos([]);
        
        if (rt && info && Object.keys(info).length > 0) {
            setBalance(info?.balance?.total);
        }
        
        const intervalIdForTransactions = setInterval( async () => {

            if (rt) {
                
                if (isNpos) {
                    await dispatch(getNposProfile());        
                } else {
                    await dispatch(getUserProfile());        
                    await dispatch(getNposList());
                }

                const timer = setTimeout( () => {
                    setLoadingImg(false);
                    clearTimeout(timer);
                }, 2000)

                clearInterval(intervalIdForTransactions);

            }

        },500);

        const intervalId = setInterval(() => {
            
            if (rt) {
                setLoadingBalance(true);
                if (isNpos) dispatch(getNposProfile(true));
                else dispatch(getUserProfile(true))
                const timer = setTimeout( () => {
                    setLoadingBalance(false);
                    clearTimeout(timer);
                },1000)
            }

        }, 10000);

        return () => {
            clearInterval(intervalId);
            clearInterval(intervalIdForTransactions)
        };

    },[rt])

    useEffect( () => {
        if (info && Object.keys(info).length > 0) setBalance(info?.balance?.total);
    },[dispatch, info])

    // Withdrawal
    const handleWithdrawal = () => {
        if (balance && balance >= 50) {
            dispatch(setModalSignInUp(modalTypeEnum.withdrawal));
            dispatch(setModalStatus(modalStatusEnum.info));
        }
    }

    const toggleFilters = () => {
        setShowFilter(!showFilter);
    }

    const handleClick = (e: React.MouseEvent<HTMLSpanElement>) => {
        const selectedSpan = e.currentTarget.innerHTML;
        e.currentTarget.classList.toggle('active');

        const a = selectedNpos;
        const index = a.indexOf(selectedSpan.toString());

        if (index > -1) a.splice(index,1);
        else a.push(selectedSpan);

        setSelectedNpos(a);

        if (timerRef.current) {
            clearTimeout(timerRef.current);
        }

        timerRef.current = setTimeout( async () => {
            try {
                setLoadingActivities(true);
                let npos = {};
                if (selectedNpos.length > 0) {
                    npos = {npos_names:selectedNpos}
                }
                const cursor = btoa(JSON.stringify(npos))
                await dispatch(getUserTransactionHistory(limit, order, cursor));
                setLoadingActivities(false);
            } catch (err) {
                console.log(err)
                setLoadingActivities(false);
            }
        }, 1000)
    };

    const checkIfActive = (e:any) : string=> {
        const els = selectedNpos;
        const index = els.indexOf(e);
        if (index > -1) return `active`
        else return '';
    }

    // modal info
    const [showInfoModal, setShowInfoModal] = useState<boolean>(false);

    const showModalInfoClick = () => {
        setShowInfoModal(!showInfoModal);
    }
    
    return (
        <>
            <div className="history-wrapper">

                <div className="header"></div>                

                { info && info.balance && (
                    <div className="amount-header">
                        <div className="amount-wrapper">
                            <span className='text-cyan opacity'>Saldo:</span>

                            <div className='flex amount-flex'>
                                {
                                    balance !== null ? 
                                    <Amount value={balance} format={false} mini={true} currency={info?.balance?.currency_total.replace(`fiat`,'')} /> 
                                    : <Skeleton variant='text' />
                                }
                                { loadingBalance && <img src={Spinner} alt="spinner" /> }
                            </div>

                            <img src={Caution} alt="Progress" className='amount-icon' onClick={showModalInfoClick} />
                        </div>

                        {!isNpos && (
                            <div className="history-icons">

                                <figure className={balance !== null && balance < 50 ? 'disabled' : ''} onClick={() => handleWithdrawal()}>
                                    <div className="img">
                                        <img src={Withdraw} alt="Withdraw" />
                                        <span>Enviar</span>
                                    </div>
                                </figure>

                                { balance !== null && balance < 50 &&
                                    <>
                                        <div className="text-danger">
                                            Valor mínimo <b>(R$ 50,00)</b> nao alcançado para envio
                                        </div>
                                    </>
                                }

                            </div>
                        )}
                        {isNpos && <div></div>}

                    </div>
                )}

                { isNpos && <h1 className='list-npos'>lista de Atividades desse NPOS</h1>}


                <>
                    {loadingActivities ? (
                        <div className='loading'>
                            <img src={Loading} alt="" />
                        </div>
                    ): (
                        <>
                            { !isNpos && <>
                                <h2 className='subtitle' onClick={toggleFilters}> </h2>

                                <div className={`tag-selector ${showFilter ? 'active' : ''}`}>
                                    <h3>Filtro de NPoS</h3>
                                    <div className="list">
                                        
                                        { listNpos && listNpos.length > 0 && listNpos.map((element, index) => (
                                            <span key={index} onClick={(e) => handleClick(e)} className={checkIfActive(element)}>{element}</span>
                                        ))}

                                        { listNpos && listNpos.length === 0 && 
                                            <><p>Essa conta nao possui NPoSs</p></>
                                        }

                                    </div>
                                    <i onClick={toggleFilters}><img src={Chevron} alt="" className={`tag-selector-icon ${showFilter ? 'active' : ''}`}/></i>
                                </div>
                            </>}
                            {payments.length === 0 ? (
                                <div className='no-transactions'>
                                    <img src={Start} alt="Start" />
                                    <p>
                                        Nenhuma transação realizada. Comece agora a usar o APP e aproveite os benefícios que esse novo método de pagamento oferece!
                                    </p>
                                </div>
                            ) : (
                                <>

                                    
                                    <TransactionList items={payments} />
                                    
                                    <div className="ref">
                                        { paymentHistory.has_next && payments.length > 0 && !loadingImg && 
                                            <div className="history-loader loaderTrk" ref={ref}>
                                                <TRKLoader />
                                            </div>
                                        }
                                    </div>
                                </>
                            )}
                        </>
                    )}
                </>
            </div>

            {/* Modal Transfer */}
            <ModalTransfer />
            <div className={`card modal-exchange history ${showInfoModal ? 'active' :  ''}`}>
                
                <div className="card-body">
                    
                    <h1>
                        Como funciona o envio <img src={Send} alt="" />
                    </h1>

                    <div className="modal-card">
                        <p className='poppins-regular'>
                            Ao optar pelo envio de valores para a carteira cadastrada em sua conta, a transação será processada via blockchain e realizada em USDT.
                        </p>

                        <h2><span className="brl">1.</span> Resgatar compras ainda não convertidas em USDT. </h2>
                        <p className='poppins-regular'>
                            A conversão de compras anteriores ainda não transformadas em USDT será realizada nesta tela, com base na cotação do dólar no momento do saque. O valor convertido será somado ao total a ser enviado.
                        </p>

                        <h2><span className="brl">2.</span> Verificar valor total do envio. </h2>
                        <p className='poppins-regular'>
                            No passo 2, aqui teremos o valor total das transações que já foram efetuadas a troca para USDT, e esse valor já estará garantido em sua carteira.
                        </p>

                        <h2><span className="brl">3.</span> Número da carteira registrada. </h2>
                        <p className='poppins-regular'>
                            Prossiga somente se a carteira exibida for reconhecida por você e corresponder exatamente à que está registrada em sua conta.
                        </p>

                        <h2><span className="brl">4.</span> Confirmação ou Erro. </h2>
                        <p className='poppins-regular'>
                            Aqui você verá se o envio para sua carteira foi bem-sucedido ou falhou.
                        </p>

                    </div>

                </div>

                <hr />

                <div className="card-footer">
                    <button className='btn' onClick={showModalInfoClick}>
                        Entendi
                    </button>
                </div>
            </div>

            <div className={`shadow ${showInfoModal ? 'active' :  ''}`}></div>

        </>
    );
}
